const ChatbotRoutes = {
  getChatbotSetting: 'gpt/project/setting',
  updateChatbotSetting: 'gpt/project/setting',
  uploadChatbotAvatar: 'gpt/project/setting/uploadavatar?',
  uploadChatbotBg: 'gpt/project/setting/uploadchatbotbg?',
};

export default ChatbotRoutes